import React from 'react';

const ChatBubble = ({ sender, name, avatar, message, variant, timestamp }) => {
  const isUser = sender === 'user';

  const bubbleClass = variant === 'white'
    ? 'bg-white text-gray-900 shadow-md'
    : isUser
      ? 'bg-red-500 text-white'
      : 'bg-orange-900/10 text-stone-800';

  const isPDFComponent = typeof message !== 'string';

  return (
    <div className={`flex items-end gap-4 ${isUser ? 'justify-end' : 'justify-start'} w-full`}>
      {!isUser && (
        <div className="w-10 h-10 rounded-full overflow-hidden border border-stone-300">
          <img
            src={avatar}
            alt={`${name} avatar`}
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <div
        className={`max-w-[600px] px-5 py-4 shadow-sm ${bubbleClass} 
          ${isUser ? 'rounded-t-2xl rounded-bl-2xl' : 'rounded-tr-2xl rounded-bl-2xl'} 
          text-base font-normal font-sora leading-tight`}
      >
        {name && !isUser && (
          <p className="text-xs text-stone-600 font-medium mb-1">{name}</p>
        )}

        {isPDFComponent ? (
          <div className="text-blue-600 text-sm font-semibold">
            {message}
          </div>
        ) : (
          <p className="whitespace-pre-line">{message}</p>
        )}

        {timestamp && (
          <p className="text-[10px] text-stone-400 mt-2 text-right">{timestamp}</p>
        )}
      </div>

      {isUser && (
        <div className="w-10 h-10 rounded-full overflow-hidden border border-stone-300">
          <img
            src={avatar}
            alt="Your avatar"
            className="w-full h-full object-cover"
          />
        </div>
      )}
    </div>
  );
};

export default ChatBubble;
